import React, { useEffect, useState } from 'react'
import './NewDasboard.css'
import TopCards from './TopCards'
import { Col, Modal, Row } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom';
import DashboardTitle from '../../data/dashboard/DashboardTitle';
import DashBoardData from '../../data/dashboard/DashBoardData';
import { useSelector } from 'react-redux';
import DataList from "../../components/listDisplay/dataList/DataList";
import NumPagination from '../../components/listDisplay/numPagination/NumPagination';
import DashboardUsertitle from '../../data/dashboard/DashboardUsertitle';
import DashboardUserData from '../../data/dashboard/DashboardUserData';
import IssueCards from './IssueCards';
import StackedBar from '../../components/dashboard/charts/StackedBar';
import DashboardTimelineSection from './DashboardTimelineSection';
import { ServerAddress } from '../../constants/ServerAddress';
import axios from 'axios';
import toTitleCase from '../../lib/titleCase/TitleCase';
import HeaderHero from './HeaderHero';
import { IoMdWarning } from 'react-icons/io';
import { FaCalendar, FaClock, FaLevelUpAlt, FaTasks } from 'react-icons/fa';
import MassageBox from './massages/MassageBox';
import IssueSection from './IssueSection';
import TaskTracker from './TaskTracker';
import TodoCard from './TodoCrad';
import Attendance from './Attendance';
import ManagerDashboard from './Manager/ManagerDashboard';
import TaskSection from './TaskSection';
import MessageBox from './Manager/MessageBox';
import { ColorRing } from 'react-loader-spinner';


const NewDasboard = ({ greeting, setcounter, counter }) => {
    const AccessToken = useSelector((state) => state.authentication.access_token);
    const userdetails = useSelector((state) => state.authentication.userdetails);


 const data_len = useSelector((state) => state.pagination.data_length);
  const page_num = useSelector((state) => state.pagination.page_number);
  const search = useSelector((state) => state.searchbar.search_item);

    // modal related information
    const [showM, setShowM] = useState(false);
    const handleCloseM = () => setShowM(false);
    const handleOpenM = () => setShowM(true);

    const [showM2, setShowM2] = useState(false);
    const handleCloseM2 = () => setShowM2(false);
    const handleOpenM2 = () => setShowM2(true);
    const [today_data, settoday_data] = useState('')



    // -------------------------------------dashboard data 
    const [total_assigned_tasks, settotal_assigned_tasks] = useState(0)
    const [total_issue, settotal_issue] = useState(0)
    const [prevPresent, setPrevPresent] = useState(0)
    const [prevAbsent, setPrevAbsent] = useState(0)
    const [totalsolved_issue, settotalsolved_issue] = useState(0)
    const [total_pending_issue, settotal_pending_issue] = useState(0)
    const [total_project, settotal_project] = useState(0)
    const [total_user, settotal_user] = useState(0)
    const [total_attendance, settotal_attendance] = useState(0)
    const [total_absence, settotal_absence] = useState(0)
    const [leave_data, setleave_data] = useState(0)
    const [holiday_data, setholiday_data] = useState()
    const [last_ten_leave, setlast_ten_leave] = useState()
    const [last_ten_correction, setlast_ten_correction] = useState()
    const [userData, setUserData] = useState(0)
    const [last_five_issues, setlast_five_issues] = useState(0)
    const [last_ten_issues, setlast_ten_issues] = useState(0)
    const [last_five_tasks, setlast_five_tasks] = useState(0)
    const [show_loader, setshow_loader] = useState(false)
    const department = userdetails?.emp_department?.[0]


    const dashboard = async () => {
    setshow_loader(true)

        try {
            const response = await axios.get(
                ServerAddress +
                `ems/user_dashboard/?p=${1}&records=${10}&name_search=${'org_search_item'}&user_id=${'user_id'}`,
                {
                    headers: { Authorization: `Bearer ${AccessToken}` },
                },
            );

            if (response) {
                setshow_loader(false)
                console.log("first========>", response.data[0])
                settotal_assigned_tasks(response.data[0].total_assigned_tasks)
                settotal_issue(response.data[0].total_issue)
                settotalsolved_issue(response.data[0].total_resolved)
                settotal_pending_issue(response.data[0].total_pending)
                settotal_project(response.data[0].total_project)
                settotal_user(response.data[0].user_data)
                settotal_user(response.data[0].user_data)
                settotal_attendance(response.data[0].attendance_data)
                settotal_absence(response.data[0].total_absence)
                setleave_data(response.data[0].leave_data)
                setcounter(response.data[0].holiday_data)
                setPrevPresent(response.data[0].atten_prev_month_present)
                setPrevAbsent(response.data[0].atten_prev_month_absent)
                setUserData(response.data[0])
                setlast_five_issues(response.data[0].last_five_issues)
                setlast_ten_issues(response.data[0].last_ten_issues)
                setlast_five_tasks(response.data[0].last_five_tasks)
                setlast_ten_leave(response?.data[0]?.last_ten_leaves)
                setlast_ten_correction(response?.data[0]?.last_ten_correction)
                setdummyAttendanceData(response.data[0].last_30_days_attendance)

            }

        } catch (err) {
            setshow_loader(false)
            console.log(`Error Occur in Get, ${err}`);
        }
    }

    useEffect(() => {
        if (AccessToken) {
            dashboard()
        }
    }, [])

    function formatTime(timeStr) {
        if (!timeStr) return "";

        try {
            const [hoursStr, minutesStr] = timeStr.split(":");
            let hours = parseInt(hoursStr, 10);
            if (isNaN(hours)) return "";

            const minutes = (minutesStr || "00").padStart(2, "0");
            const ampm = hours >= 12 ? "PM" : "AM";

            hours = hours % 12 || 12;

            return `${hours}:${minutes}${ampm}`;
        } catch (e) {
            console.error("Error formatting time:", e);
            return "";
        }
    }

    const clock_time = userdetails?.clock_in?.[0];


    // <=============================Issues Component data====================================>
    const [dummyAttendanceData, setdummyAttendanceData] = useState('')
    // console.log("dummyAttendanceData--------->",dummyAttendanceData)

    return (
        <>

            <HeaderHero userdetails={userdetails} userData={userData} greeting={greeting} />
            {/* <========================= Team view Dashboard ===========================*/}
            {(userdetails?.is_superuser || department?.name === "HR") ? <ManagerDashboard last_ten_leave={last_ten_leave}  last_ten_correction={last_ten_correction} last_ten_issues={last_ten_issues} show_loader={show_loader}/> :
                <>
                 {show_loader ? (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            position: 'fixed',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            zIndex: '999'
                          }}
                          aria-labelledby='contained-modal-title-vcenter'
                        >
                          <div className='loader-container'>
                            <ColorRing
                              visible={true}
                              height='160'
                              width='160'
                              ariaLabel='blocks-loading'
                              wrapperStyle={{}}
                              wrapperClass='blocks-wrapper'
                              colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                            />
                          </div>
                        </div>
                      ) : null}
                    <Row className="header-stats-row" lg={12} md={12} sm={12} >
                        <Col className="header-stats-main-col" lg={7} md={12} sm={12}>
                            <Row className="header-stats-cards-row" style={{ paddingLeft: '10px' }}>
                                <Col className="header-stats-card-col" lg={4} md={4} sm={6}>
                                    <div className="header-stats-card">
                                        <div className="header-stats-content">
                                            <div className="header-stats-header">
                                                <div className="header-stats-icon" style={{ backgroundColor: '#FF9800' }}>
                                                    <IoMdWarning size={16} color="white" />
                                                </div>
                                                <h3 className="header-stats-title">Issue</h3>
                                            </div>
                                            <div className="header-stats-info">
                                                <div className="header-stats-data">
                                                    <span className="header-stats-label">Assigned</span>
                                                    <h4 className="header-stats-value">{total_issue}</h4>
                                                </div>
                                                <div className="header-stats-data">
                                                    <span className="header-stats-label">Solved</span>
                                                    <h4 className="header-stats-highlight">{totalsolved_issue}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                                <Col className="header-stats-card-col" lg={4} md={4} sm={6}>
                                    <div className="header-stats-card">
                                        <div className="header-stats-content">
                                            <div className="header-stats-header">
                                                <div className="header-stats-icon" style={{ backgroundColor: '#2196F3' }}>
                                                    <FaTasks size={16} color="white" />
                                                </div>
                                                <h3 className="header-stats-title">Task</h3>
                                            </div>
                                            <div className="header-stats-info">
                                                <div className="header-stats-data">
                                                    <span className="header-stats-label">Assigned</span>
                                                    <h4 className="header-stats-value">{total_assigned_tasks ? total_assigned_tasks : '0'}</h4>
                                                </div>
                                                <div className="header-stats-data">
                                                    <span className="header-stats-label">Solved</span>
                                                    <h4 className="header-stats-highlight">0</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                                <Col className="header-stats-card-col" lg={4} md={4} sm={6}>
                                    <div className="header-stats-card">
                                        <div className="header-stats-content">
                                            <div className="header-stats-header">
                                                <div className="header-stats-icon" style={{ backgroundColor: '#E91E63' }}>
                                                    <FaLevelUpAlt size={16} color="white" />
                                                </div>
                                                <h3 className="header-stats-title">Leave</h3>
                                            </div>
                                            <div className="header-stats-info">
                                                <div className="header-stats-data">
                                                    <span className="header-stats-label">Assigned</span>
                                                    <h4 className="header-stats-value">12</h4>
                                                </div>
                                                <div className="header-stats-data">
                                                    <span className="header-stats-label">Remaining</span>
                                                    <h4 className="header-stats-highlight">8</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>


                                <Col className="header-stats-card-col" lg={4} md={4} sm={6}>
                                    <div className="header-stats-card">
                                        <div className="header-stats-content">
                                            <div className="header-stats-header">
                                                <div className="header-stats-icon" style={{ backgroundColor: '#4CAF50' }}>
                                                    <FaCalendar size={16} color="white" />
                                                </div>
                                                <h3 className="header-stats-title">Attendance</h3>
                                            </div>
                                            <div className="header-stats-info">
                                                <div className="header-stats-data">
                                                    <span className="header-stats-label">Present</span>
                                                    <h4 className="header-stats-value">{prevPresent}</h4>
                                                </div>
                                                <div className="header-stats-data">
                                                    <span className="header-stats-label">Absent</span>
                                                    <h4 className="header-stats-highlight">{prevAbsent}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col className="header-stats-card-col" lg={4} md={4} sm={6}>
                                    <div className="header-stats-card">
                                        <div className="header-stats-content">
                                            <div className="header-stats-header">
                                                <div className="header-stats-icon" style={{ backgroundColor: '#4CAF50' }}>
                                                    <FaCalendar size={16} color="white" />
                                                </div>
                                                <h3 className="header-stats-title">Attendance Mark</h3>
                                            </div>
                                            <div className="header-stats-info">
                                                <div className="header-stats-data">
                                                    <span className="header-stats-label">Today</span>
                                                    <h4 className="header-stats-value">{clock_time?.attendance_mark}</h4>
                                                </div>
                                                {/* <div className="header-stats-data">
                                            <span className="header-stats-label">Absent</span>
                                            <h4 className="header-stats-highlight">4</h4>
                                        </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                                <Col className="header-stats-card-col" lg={4} md={4} sm={6}>
                                    <div className="header-stats-card">
                                        <div className="header-stats-content">
                                            <div className="header-stats-header">
                                                <div className="header-stats-icon" style={{ backgroundColor: '#9C27B0' }}>
                                                    <FaClock size={20} color="white" />
                                                </div>
                                                <h3 className="header-stats-title">Time Log</h3>
                                            </div>
                                            <div className="header-stats-info">
                                                <div className="header-stats-data">
                                                    <span className="header-stats-label">CheckIn</span>
                                                    <h4 className="header-stats-value">{formatTime(clock_time?.clock_in)}</h4>
                                                </div>
                                                <div className="header-stats-data">
                                                    <span className="header-stats-label">CheckOut</span>
                                                    <h4 className="header-stats-highlight">{formatTime(clock_time?.clock_out)}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>

                        <Col lg={5} md={12} sm={12}>
                            <MassageBox />
                        </Col>
                    </Row>
                    <Row className="p-1">
                        <Col lg={7} md={12} sm={12} className="mb-3 mb-lg-0" >
                            <TaskSection last_five_tasks={last_five_tasks} />
                        </Col>

                        <Col lg={5} md={12} sm={12}>
                            <Attendance attendanceData={dummyAttendanceData} />
                        </Col>
                    </Row>

                    {/* style={{border:'2px solid red'}} */}
                    {/* <========================= Second Header Card End ===========================*/}

                    <Row className="p-1">
                        <Col lg={7} md={12} sm={12} className="mb-3 mb-lg-0" >
                            
                        <IssueSection last_five_issues={last_five_issues} />

                        </Col>

                        <Col lg={5} md={12} sm={12}>
                            <TodoCard />
                        </Col>
                    </Row>
                </>
            }
            {/* <===================================Team View dashboard End============================> */}

        </>
    )
}

export default NewDasboard